import React from "react";
import styled from "styled-components";

import { Announcement, FixedIssueTopicInfo } from '../../../AnnouncementInfo';
import { ResourceStrings } from '../../../ResourceStrings';
import { Icon } from "@fluentui/react/lib/Icon";
import { AppPaths } from "../../../constants/urls";
import { Link } from "react-router-dom";

export interface AnnouncementSummaryProps {
    announcement: Announcement;
}

export default function AnnouncementSummary(props: AnnouncementSummaryProps): JSX.Element {
    const fixedTopicCount: number = props.announcement.fixedInTopics.length;
    // The announcements API returns fixes in reverse chronological order so pick first one
    const topic: FixedIssueTopicInfo | null = fixedTopicCount > 0 ? props.announcement.fixedInTopics[0] : null;

    return <Container>
        <div className="completed-feedback">
            {topic && <div key={0}>
                <div className="icon-row"><Icon iconName="WaitlistConfirm" /></div>
                <Link
                    className="a emphasize"
                    aria-label={ResourceStrings.resolvedProblemsCount(topic.issueCount, topic.shortName)}
                    to={`${AppPaths.fixes}`}>
                    {ResourceStrings.resolvedProblemsCount(topic.issueCount, topic.shortName)}
                    <Icon className="small-icon" iconName="ChevronRight" />
                </Link>
            </div>}
        </div>
        <div className="detail-text">Visual Studio <a href="https://docs.microsoft.com/en-us/visualstudio/productinfo/vs-roadmap?utm_source=devcom" target="_blank" rel="noopener noreferrer">roadmap</a> and <a href={props.announcement.moreInfoUrl} target="_blank" rel="noopener noreferrer">release notes</a></div>
    </Container>;
}

const Container = styled.div`
    .completed-feedback {
        margin-bottom: 0.6rem;
    }
    .completed-feedback i {
        font-size: 0.63em;
        font-weight: bold;
    }
    .title-container {
        vertical-align: bottom;
    }

    .icon-row i {
        margin-bottom: 1rem;
        font-size: 2.8rem;
        font-weight: normal;
        color: var(--color-on-primary);
        background-color: var(--color-primary);
        width: 5.2rem;
        height: 5.2rem;
        line-height: 5.2rem;
        vertical-align: middle;
        border-radius: 50%;
    }

    .title {
        font-size: 1.8rem;
        font-weight: 500;
        color: #000000;
        display: inline-block;
    }

    .subtitle {
        color: #555555;
        padding-left: 0.7rem;
        display: inline-block;
    }

    .date {
        font-weight: 500;
        margin: 1.6rem 0 1rem 0;
    }

    .summary-text {
        width: 66%;
        margin-bottom: 1rem;
        color: #333333;
        padding: 1rem 0 0.8rem 0;
    }

    .title2 {
        font-size: 2.5rem;
        line-height: 2.9rem;
        margin-bottom: 1.1rem;
        color: #555555;
    }

    .cell {
        display: inline-block;
        vertical-align: top;
    }

    .cell.up {
        position: relative;
        top: -0.8rem;
    }

    button.download {
        display: block;
        font-size: 2.2rem;
        color: white;
        background: #1E73BE;
        padding: 0.7rem 3.2rem 0.8rem 3.2rem;
        line-height: 2.6rem;
        margin: 2.8rem 20rem 1rem 0;
        text-decoration: none;
    }

    button.download:hover {
        background: #1f78c7;
        text-decoration: none;
    }

    button.emphasize, a.emphasize {
        font-size: 2.4rem;
        font-weight: 600;
    }

    .detail-text {
        font-size: 1.8rem;
    }

    .detail-text a {
        font-size: 2rem;
        font-weight: 600;
    }
`